import { useMemo } from "react";
import { array, mixed, object, string } from "yup";
import moment from "moment";
import { MIN_ALLOWED_AGE } from "consts/general";
import { FormField } from "./types";

const useValidationSchema = () =>
    useMemo(() => (
        object().shape({
            uboIdentities: array().of(
                object().shape({
                    [FormField.FullName]: string()
                        .required()
                        .label('First Name'),

                    [FormField.DateOfBirth]: string()
                        .required()
                        .nullable()
                        .label('Date of Birth')
                        .test(
                            'is-adult',
                            'You must be an adult to proceed',
                            value => moment().diff(value, 'years') >= MIN_ALLOWED_AGE
                        ),

                    [FormField.Nationality]: array()
                        .of(string())
                        .nullable()
                        .min(1, 'Select at least one Nationality')
                        .label('Nationality'),

                    [FormField.ResidentialAddress]: string()
                        .required()
                        .label('Residential Address'),

                    [FormField.LegalForm]: string()
                        .required()
                        .label('Legal Form'),

                    [FormField.IdentityFileKey]: mixed()
                        .required()
                        .label('Identity Document'),

                    [FormField.AddressFileKey]: mixed()
                        .required()
                        .label('Proof of Residential Address')
                })
            )
        })
    ), []);

export default useValidationSchema;
